import {CounterInputStyle} from "../cart.style";
import {Button} from "reactstrap";
import {FaMinus, FaPlus} from "react-icons/fa6";

const CounterInput = ({ value = 1, max = 1, min = 1, onChange }) => {
    const increase = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onChange(Math.min(value + 1, max ?? value + 1));
    };

    const decrease = (e) => {
        e.stopPropagation();
        e.preventDefault();
        onChange(Math.max(value - 1, min));
    };

    const handleInputClick = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    return (
        <CounterInputStyle onClick={handleInputClick} className="relative flex items-center">
            <Button disabled={value <= min} onClick={decrease} size="sm" type="button">
                <FaMinus size={18} />
            </Button>
            <input value={value} readOnly type="text" id="counter-input" required />
            <Button disabled={value >= max} onClick={increase} size="sm" type="button">
                <FaPlus size={18} />
            </Button>
        </CounterInputStyle>
    );
};
export default CounterInput